import { EnvironmentProviders, Provider } from '@angular/core';

import { WebSocketsService } from './websockets.service';

export function provideWebsockets(): Array<Provider | EnvironmentProviders> {
  return [WebSocketsService];
}
